import {createTheme} from "@mui/material/styles";

export const theme = createTheme({
    palette: {
        primary: {
            light: "rgb(134, 178, 95)",
            main: "#bfff00",
            dark: "#93c10a",
            contrastText: "#000000"
        },
        secondary: {
            light: "rgb(255, 167, 51)",
            main: "#ff9100",
            dark: "rgb(178, 101, 0)",
            contrastText: "#000000"
        },
        background: {
            dark: "#b2b2b2",
            default: "#ffffff",
            light: "#ffffff",
            darkText: "#000000",
            text: "#111111",
            lightText: "#222222",
            primaryText: "#689f38",
            secondaryText: "#ff9100"
        }
    },
    components: {
        MuiButton: {
            defaultProps: {
                color: "primary"
            },
            styleOverrides: {
                root: {
                    textTransform: "none"
                },
                containedPrimary: {
                    color: "#000000"
                }
            }
        }
    }
});

// Keep a single source of truth for buttons; legacy imports will use the main theme.
export const buttonTheme = theme;
